(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-registro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-b2b-scroll]');
    if (!link) return;
    e.preventDefault();
    // Baja hasta la siguiente sección de la página (el formulario)
    const current = link.closest('.shopify-section');
    let next = current && current.nextElementSibling;
    while (next && !next.classList.contains('shopify-section')) next = next.nextElementSibling;
    const target = next || document.querySelector('form');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
